import EmptyPage from "../../../components/empty-page/empty-page.component";

const Practices = () => <EmptyPage title="Практична підготовка" />;

export default Practices;
